import { ReactElement, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import styles from './PhoneFlagText.module.scss';

interface IProps {
  value?: string;
}

const PhoneFlagText = ({ value = '' }: IProps): ReactElement => {
  const [formattedPhone, setFormattedPhone] = useState('');

  return (
    <>
      <div className={styles.phoneInputContainer}>
        <PhoneInput
          key={value}
          country="us"
          regions={['north-america', 'europe']}
          value={value}
          onMount={(_val, _data, formattedValue) => setFormattedPhone(formattedValue)}
        />
      </div>
      {formattedPhone || '-'}
    </>
  );
};

export default PhoneFlagText;
